import { isArrayWithValue } from '@/utils/helpers/isArrayWithValue';
import { IFeatureCards } from '@/utils/interfaces/bloks';
import { StoryblokComponent } from '@storyblok/react';
import { CTA } from '../Shared/CTA/CallToAction';
import { FormattedText } from '../Shared/FormattedText';
import { Container } from '../Shared/Layout/Container';
import { SbSection } from '../Shared/Layout/SbSection';
import { features } from 'process';

interface IProps {
	blok: IFeatureCards;
	preview: boolean;
}

export const SimpleFeatureTiles: React.FC<IProps> = ({ blok, preview }) => {
	return (
		<SbSection
			blok={blok}
			preview={preview}
			classNames="relative py-[42px]"
		>
			<Container align="center">
				<FormattedText tag="h2" text={blok.heading} />
				<span className="block mt-4 font-normal opacity-80 text-gray-dark lg:text-[20px] max-w-[500px] mx-auto lg:mt-6">
					{blok.sub_heading}
				</span>

				{isArrayWithValue(blok.features) && (
					<div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10 md:mt-8">
						{blok.features.map((feature, key) => (
							<div
								key={key}
								className="col-4"
							>
								<StoryblokComponent blok={feature} />
							</div>
						))}
					</div>
				)}

				{isArrayWithValue(blok.cta) && (
					<div className="flex justify-center mt-10 md:mt-14">
						{blok.cta.map((cta, key) => {
							return <CTA blok={cta} key={key} />;
						})}
					</div>
				)}
			</Container>
		</SbSection>
	);
};
